import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from "@angular/core";
import { Paginator } from 'primeng/paginator';
import { FormBuilder, FormGroup, NgForm, Validators } from "@angular/forms";
import { EditorComponent } from "@progress/kendo-angular-editor";
import { map, concatMap} from 'rxjs/operators';
import { from, Subscription } from "rxjs";
import { ToastrService } from 'ngx-toastr';
import { EmailClientService } from "../service/email-client.service";
import { CustomErrorToastComponent } from "custom-error-toast";

@Component({
  selector: "outlook-email-client-table",
  templateUrl: "./outlook-email-client-table.component.html",
  styleUrls: ["./outlook-email-client-table.component.scss"],
})
export class OutlookEmailClientTableComponent implements OnInit, OnChanges {
  @Output() @ViewChild("commonkendoeditor") public commonkendoeditor: EditorComponent;
  @ViewChild('froalaForm', { static: true })
  froalaForm: NgForm;
  @Input() formControlName: string | 'floraEditor';
  commonkendoeditorStr: string;
  @ViewChild('paginator', { static: true }) paginator: Paginator;
  @Input("emailType") emailType: string;
  @Input("headerActionType") headerActionType: string;
  @Input("emailClientTableList") emailClientTableList: any = null;
  @Input("emailMessageCount") totalRecords;
  @Input("isEmailClientTable") isEmailClientTable: boolean;
  @Output() onChangeTableRowData = new EventEmitter<any>();
  @Output() onPaginationChange = new EventEmitter<any>();
  @Output() deleteMailSection = new EventEmitter<any>();
  @Output() onChangeFolder = new EventEmitter<boolean>();
  @Output() onLabelAdd = new EventEmitter<boolean>();
  isSaveSection: boolean = false;
  outlookLabelsModal:boolean=false;
  outlookMoveModal:boolean=false;
  pageSize: number = 5;
  pageNumber: number = 1;
  submitted: boolean = false;
  selectedRows: any[];
  labelDropdownList:any[];
  emailArrSubscription: Subscription;
  // emailType: string;
  messageType: string;
  first: number = 0;
  labelDropdownForm:FormGroup;
  labelForm: FormGroup;
  isMovingtoSameLabel: boolean;
  constructor(private fb: FormBuilder,
    private toastr: ToastrService,
    public emailClientService: EmailClientService) {
      this.labelForm = this.fb.group({
        label: ['',  [Validators.required]],
      });
      this.labelDropdownForm = this.fb.group({
        labeldropdown: ['',  [Validators.required]],
      });
    }

  ngOnInit(): void {
    this.totalRecords = this.totalRecords?this.totalRecords: this.emailClientService.totalrecords;
    this.selectedRows = [];
    this.emailArrSubscription = this.emailClientService.emailArrSubscription$.subscribe((emailArr: string[]) => {
      if (emailArr.length) {
        this.selectedRows = emailArr;
        if(this.emailClientService.isDeleteFromDetail){
          this.emailClientService.isDeleteFromDetail= false;
          this.deleteOutLookEmails(); //getting called twice, called one time.
        }
        this.emailArrSubscription.unsubscribe();
      }
    })
    this.first = 0;
    this.messageType = this.emailClientService.outlookMessageType;
    this.getCreatedLabels();
  }

  async getCreatedLabels(){
    await this.emailClientService.getFolders().pipe(
      map((folders:any)=>{
        return folders?.value?.filter((folder:any)=> folder.displayName.includes("IM-"))
      })).toPromise().then(
        data=> {
          this.labelDropdownList = data;
        }
      )
  }


  onCreateLabel(){
    this.submitted = true;
    if (this.labelForm.valid) {
      let labelData = this.labelForm.value;
      let data= {
        "displayName": "IM-"+labelData?.label?.trim(),
        "isHidden": false
      }
      this.emailClientService.createFolder(data).subscribe(
        message=> {
          if (message.status === 201 ) {
            this.toastr.success("Label created successfully.", 'Success');
            // dispaly to left side menu 
            this.onLabelAdd.emit(true);
          }
        },
        error=> {
          CustomErrorToastComponent.showErrorToast(this.toastr, error?.error?.error?.message);
        }
      )
      this.outlookLabelsModal= false;
      this.labelForm.reset();
    }
  }

  createLabel(){
    this.outlookLabelsModal= true;
  }

  deleteOutLookEmails() {
    this.messageType = this.emailClientService.outlookMessageType;
    if (this.selectedRows.length) {
      from(this.selectedRows).pipe(
        map(data => data.id),
        concatMap(emailId => {
          return this.messageType == "Deleted Items" ?
             this.emailClientService.deleteEmailPermanently(emailId)
            : this.emailClientService.deleteEmail(emailId)
        }
        ))
        .subscribe((message: any) => {
          if (message.status === 201) {
            this.toastr.success("Email deleted successfully.", 'Success');
          }
          if (message.status === 204) {
            this.toastr.success("Email deleted permanently.", 'Success');
          }
          this.onChangeFolder.emit(true);
        },
          (error) => {
            CustomErrorToastComponent.showErrorToast(this.toastr, 'Problem occured while deleting email.');
            this.onChangeFolder.emit(false);
          })
          this.emailClientService.folderChangeSubject$.next(true);
          this.selectedRows = [];
    }
    else {
      CustomErrorToastComponent.showErrorToast(this.toastr, 'Please select email(s) to delete.');
    }
  }

  onMove(){
    let selectedValLabel = this.labelDropdownList.find(x=>x.id === this.labelDropdownForm.value.labeldropdown).displayName;
    if(this.emailClientService.outlookMessageType === selectedValLabel){
      this.isMovingtoSameLabel = true;
    }else{
      this.isMovingtoSameLabel = false;
      this.submitted = true;
      if (this.labelDropdownForm.valid) {
        let labelData = this.labelDropdownForm.value;
        this.messageType = this.emailClientService.outlookMessageType;
      let foldernameId =labelData?.labeldropdown;
      if (this.selectedRows.length) {
        from(this.selectedRows).pipe(
          map(data => data.id),
          concatMap(emailId => {
            return this.emailClientService.moveEmails(emailId,foldernameId);
          }
          ))
          .subscribe((message: any) => {
            if (message.status === 201 || message.status === 204) {
              this.toastr.success("Email moved successfully.", 'Success');
              this.outlookMoveModal= false;
              this.onChangeFolder.emit(true);
              this.selectedRows = [];
            }
          },
            (error) => {
              this.onChangeFolder.emit(true);
              CustomErrorToastComponent.showErrorToast(this.toastr, 'Problem occured while moving email.');
            })
      }
      else {
        CustomErrorToastComponent.showErrorToast(this.toastr, 'Please select email(s) to move.');
      }
      } 
    }
  }

  async moveEmails() {
    this.labelDropdownForm.reset();
    if(this.selectedRows.length){
      await this.getCreatedLabels();
      this.outlookMoveModal= true;
    }
    else {
      CustomErrorToastComponent.showErrorToast(this.toastr, 'Please select email(s) to move.');
    }
  }

  onChangeSubTaskType(param) {
    if (param.value === "reply") {
      this.isEmailClientTable = false;
      this.isSaveSection = true;
      this.onChangeTableRowData.next(this.isEmailClientTable);
    }
  }

  handleSelect(e, param) {
    if(this.emailClientService.outlookMessageType === 'Drafts'){
      this.emailClientService.emailDetailSubscription$.next(
        { read: false, emailId: param.id, emailType: 'compose-mail', replyType: 'replyAll' });
        this.emailClientService.selectedEmailId = param.id;
        this.emailClientService.selectedReplyType = 'replyAll';
        if(this.messageType==="Drafts"){
          this.emailClientService.preservedMessageTypeForDraft = this.messageType;
        }
    }else{
      this.emailClientService.emailDetailSubscription$.next({ read: true });
      this.onChangeTableRowData.next(param);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.pageSize = 5;
    this.pageNumber = 1;
    this.totalRecords = changes.totalRecords?.currentValue ? changes.totalRecords.currentValue : 0;
    this.emailClientTableList = changes.emailClientTableList.currentValue;
    this.messageType = this.emailClientService.outlookMessageType;
  }
  deleteMail(data) {
    this.deleteMailSection.next(data);
  }

  paginate(event) {
    const paginate = {
      skipItems: event.page * event.rows,
      topItems: event.rows,
    }
    this.onPaginationChange.emit(paginate)
  }
}